import React from 'react';
import { Button, makeStyles, Typography, useTheme } from '@material-ui/core';
import { useAuth } from 'react-oidc-context';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15%',
  },
  textSpacing: {
    paddingBottom: '1.5rem',
  },
  email: {
    color: '#323232',
  },
}));

export const Unauthorized: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { signoutRedirect } = useAuth();

  return (
    <div className={classes.container}>
      <Typography variant={'h4'} className={classes.textSpacing}>
        Unauthorized
      </Typography>
      <Typography className={classes.textSpacing}>
        You do not have access to this site. To request access, please email{' '}
        <a className={classes.email} href="mailto:digitalorders@jhtsoftware.zendesk.com">
          digitalorders@jhtsoftware.zendesk.com
        </a>{' '}
      </Typography>
      <Button
        data-test-id="login-button"
        onClick={() => void signoutRedirect()}
        variant="contained"
        color="primary"
      >
        Log Out
      </Button>
    </div>
  );
};
